<template>
  <v-form v-model="valid" ref="fullForm">
    <v-container>
      <v-row justify="center" alignment="center" no-gutters class="heading-row">
          <v-col cols="2" md="1" class="rays-left">
              <!--   v-img
                :src="lashesLeft.src"
                contain
                :max-height="lashHeight"
                max-width="22px"
                class="float-right margin-sm-right"
                v-show="$vuetify.breakpoint.mdAndUp"
              ></img>
              <v-img
                :src="lashesLeft.src"
                contain
                max-height="36"
                max-width="22px"
                class="float-right margin-sm-right"
                v-show="$vuetify.breakpoint.smAndDown"
              ></v-img -->
          </v-col>
          <v-col cols="8" md="auto" class="text-white heading-block">
              <div class="green-slant"><h1 class="center-text arla-strong" :class="{'small-heading': $vuetify.breakpoint.smAndDown}">{{this.langData.entry.title}}</h1></div>
          </v-col>
          <v-col cols="2" md="1" class="rays-right">
              <!--  v-img
                :src="lashesRight.src"
                contain
                :max-height="lashHeight"
                max-width="22px"
                class="float-left margin-sm-left"
                v-show="$vuetify.breakpoint.mdAndUp"
              ></v-img>
              <v-img
                :src="lashesRight.src"
                contain
                max-height="36"
                max-width="22px"
                class="float-left margin-sm-left"
                v-show="$vuetify.breakpoint.smAndDown"
              ></v-img -->
          </v-col>
      </v-row>

      <v-row justify="center" alignment="center">
          <v-col cols="10" md="7" class="text-green" ref="termsClick">
              <p class="center-text mid-size"><b v-html="this.langData.entry.body"></b></p>
          </v-col>
      </v-row>

      <v-row
      justify="center"
      alignment="center"
    >
      <v-col cols="10" md="4">
        <v-text-field
          v-model="form.firstname"
          :rules="rules.firstName"
          :label="langData.entry.fieldLabels.fName"
          required
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="10" md="4">
        <v-text-field
          v-model="form.lastname"
          :rules="rules.lastName"
          :label="langData.entry.fieldLabels.lName"
          required
          filled
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row
      justify="center"
      alignment="center"
    >
      <v-col cols="10" md="4">
        <v-text-field
          v-model="form.email"
          :rules="rules.emailInput"
          :label="langData.entry.fieldLabels.email"
          required
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="10" md="4">
        <v-text-field
          v-model="form.emailConfirm"
          :error="emailConfirmError"
          :error-messages="emailConfirmErrorMessage"
          @change="validateEmail()"
          :label="langData.entry.fieldLabels.emailCon"
          required
          filled
          v-on:blur="validateEmail"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row
      justify="center"
      alignment="center"
    >
      <v-col cols="10" md="4">
        <v-text-field
          v-model="form.address1"
          :rules="rules.address1"
          :label="langData.entry.fieldLabels.address1"
          required
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="10" md="4">
        <v-text-field
          v-model="form.address2"
          :rules="rules.address2"
          :label="langData.entry.fieldLabels.address2"
          required
          filled
          v-if="uk"
        ></v-text-field>
        <v-text-field
          v-model="form.address3"
          :rules="rules.address3"
          :label="langData.entry.fieldLabels.town"
          required
          filled
          v-else
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row
      justify="center"
      alignment="center"
      v-if="uk"
    >
      <v-col cols="10" md="4">
        <v-text-field
          v-model="form.address3"
          :rules="rules.address3"
          :label="langData.entry.fieldLabels.town"
          required
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="10" md="4">
        <v-text-field
          v-model="form.postcode"
          :rules="rules.postcode"
          :label="langData.entry.fieldLabels.postcode"
          required
          filled
          maxlength="8"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row
      justify="center"
      alignment="center"
      v-else
    >
      <v-col cols="10" md="4">
        <v-text-field
          v-model="form.postcode"
          :rules="rules.postcodeNL"
          :label="langData.entry.fieldLabels.postcode"
          required
          filled
          maxlength="8"
        ></v-text-field>
      </v-col>
    </v-row>

      <v-row justify="center" alignment="center">
        <v-col cols="10" md="4">
            <h2 class="text-center text-green code-title">{{langData.entry.codeTitle}}</h2>
          <v-text-field
            v-model="form.code"
            :label="langData.entry.fieldLabels.code"
            filled
            :error="codeError"
            error-messages=""
            class="right-error error-right"
            @change="cleanCode()"
            @keyup="cleanCode()"
            @blur="validateCode()"
            maxlength="9"
            v-if="uk"
          ></v-text-field>
           <v-text-field
            v-model="form.code"
            :label="langData.entry.fieldLabels.code"
            filled
            :error="codeError"
            error-messages=""
            class="right-error error-right"
            @change="cleanCode()"
            @keyup="cleanCode()"
            @blur="validateCode()"
            maxlength="9"
            v-else
          ></v-text-field>
        </v-col>
        <v-col cols="2" v-show="codeError">
          <transition name="slide-y-transition" mode="in-out">
            <div class="v-text-field__details manual-error batch-code-error" v-if="codeError">
              <div class="v-messages theme--light error--text shift-right-small">
                <div class="v-messages__wrapper">
                  <div class="v-messages__message" >{{errorMessage}}</div>
                </div>
              </div>
            </div>
          </transition>
        </v-col>
      </v-row>

      <v-row justify="center" no-gutters>
          <v-col cols="auto" class="lg-size">
              <p class="text-center">{{this.langData.entry.link1Text}} <a @click="openModalPage('where')">{{this.langData.entry.link1Cta}}</a></p>
          </v-col>
      </v-row>
      
      <v-row justify="center" alignment="center">
        <v-col cols="auto">
          <div class="anchor-captcha" :class="{'error--text': errors.captcha}"></div>
          <v-captcha ref="captchaMe" error="true" class="captcha" sitekey="6LftJ-IUAAAAAJksOmALBrpL_T5he_Q2zKixRumH" :loadRecaptchaScript="true" @verify="captchaClick" size="100px" style="transform:scale(1);-webkit-transform:scale(1);transform-origin:0 0;-webkit-transform-origin:0 0;"></v-captcha>
          <transition name="slide-y-transition" mode="in-out">
            <div class="v-text-field__details manual-error captcha-error" v-if="errors.captcha">
              <div class="v-messages theme--light error--text shift-right-small">
                <div class="v-messages__wrapper">
                  <div class="v-messages__message" >{{errors.captcha}}</div>
                </div>
              </div>
            </div>
          </transition>
        </v-col>
      </v-row>

      <v-row justify="center" alignment="center">
        <v-col cols="10" md="4">
          <v-row justify="center" alignment="center">
            <v-col cols="auto">
            <v-btn color="#fff" v-if="!uploadImage" fab x-large dark depressed class="upload-button" @click="chooseFiles('fileUploadFront')" :class="[{'small-upload': $vuetify.breakpoint.mdAndDown}, {'error' : errors.file.front}]">
              <v-icon color="#6c9778">mdi-camera</v-icon>
              <span class="button-text" v-html="langData.entry.uploadImageFront"></span>
            </v-btn>
            <v-img
              v-else
                :src="uploadImage"
                contain
                class="outline"
                align="center"
                :max-height="imageMaxHeight"
            >
              <template v-slot:placeholder>
                <v-progress-circular
                    :size="70"
                    :width="7"
                    color="#91CCC8"
                    indeterminate
                    ></v-progress-circular>
              </template>
            </v-img>
          </v-col>
          <v-col cols="auto">
              <v-file-input
                v-model="files"
                required
                filled
                prepend-icon="mdi-camera"
                id="fileUploadFront"
                ref="uploadFront"
                class="fileUploadFront"
                @change="fileFrontChanged($event)"
                accept="image/*"
              ></v-file-input>
              <h2 class="center-text upload-title">{{this.langData.entry.uploadImageTitle}}</h2>
              <span class="rays file" v-if="!uploadImage"><v-btn outlined uppercase color="#e93e8f"  @click="chooseFiles('fileUploadFront')">{{this.langData.entry.uploadImageSelect}}</v-btn></span>
              <span class="rays file" v-else><v-btn outlined uppercase color="#e93e8f"  @click="removeImage('front')">{{this.langData.entry.uploadImageRemove}}</v-btn></span>
              <transition name="slide-y-transition" mode="in-out">
                <div class="v-text-field__details manual-error upload" v-if="errors.file.front">
                <div class="v-messages theme--light error--text shift-right-small">
                    <div class="v-messages__wrapper">
                    <div class="v-messages__message" >{{errors.file.front}}</div>
                    </div>
                </div>
                </div>
              </transition>
          </v-col>
          </v-row>
        </v-col>
        <v-col cols="10" md="4">
           <v-row justify="center" alignment="center">
          <v-col cols="auto">
            <v-btn color="#fff" v-if="!uploadImageBack" fab x-large dark depressed class="upload-button" @click="chooseFiles('fileUploadBack')" :class="{'small-upload': $vuetify.breakpoint.mdAndDown}">
              <v-icon color="#6c9778">mdi-camera</v-icon>
              <span class="button-text" v-html="langData.entry.uploadImageBack"></span>
            </v-btn>
            <v-img
              v-else
                :src="uploadImageBack"
                contain
                class="outline"
                align="center"
                :max-height="imageMaxHeight"
            >
              <template v-slot:placeholder>
                <v-progress-circular
                    :size="70"
                    :width="7"
                    color="#91CCC8"
                    indeterminate
                    ></v-progress-circular>
              </template>
            </v-img>
          </v-col>
          <v-col cols="auto">
              <v-file-input
                v-model="filesBack"
                ref="uploadBack"
                required
                filled
                prepend-icon="mdi-camera"
                id="fileUploadBack"
                class="fileUploadBack"
                @change="fileBackChanged($event)"
                accept="image/*"
              ></v-file-input>
              <h2 class="center-text upload-title">{{this.langData.entry.uploadImageTitle}}</h2>
              <span class="rays file" v-if="!uploadImageBack"><v-btn outlined uppercase color="#e93e8f"  @click="chooseFiles('fileUploadBack')">{{this.langData.entry.uploadImageSelect}}</v-btn></span>
              <span class="rays file" v-else><v-btn outlined uppercase color="#e93e8f"  @click="removeImage('back')">{{this.langData.entry.uploadImageRemove}}</v-btn></span>
              <transition name="slide-y-transition" mode="in-out">
                <div class="v-text-field__details manual-error upload" v-if="errors.file.back">
                <div class="v-messages theme--light error--text shift-right-small">
                    <div class="v-messages__wrapper">
                    <div class="v-messages__message" >{{errors.file.back}}</div>
                    </div>
                </div>
                </div>
            </transition>
          </v-col>
           </v-row>
        </v-col>
      </v-row>

      

        <v-row justify="center">
          <v-col cols="auto" class="lg-size">
              <p class="text-center">{{this.langData.entry.link2Text}} <a @click="openModalPage('receipt')">{{this.langData.entry.link2Cta}}</a></p>
          </v-col>
        </v-row>
<!-- v-show="$vuetify.breakpoint.mdAndUp" -->
        <v-row justify="center" alignment="center" no-gutters class="heading-row">
            <v-col cols="1" class="rays-left">
                <!-- v-img
                    :src="lashesLeft.src"
                    contain
                    :max-height="lashHeight"
                    max-width="22px"
                    class="float-right margin-sm-right"
                    v-show="$vuetify.breakpoint.mdAndUp"
                ></v-img>
                <v-img
                    :src="lashesLeft.src"
                    contain
                    max-height="36"
                    max-width="22px"
                    class="float-right margin-sm-right"
                    v-show="$vuetify.breakpoint.smAndDown"
                ></v-img -->
            </v-col>
            <v-col cols="auto" class="text-white heading-block">
                <div class="green-slant"><h1 class="center-text arla-strong" :class="{'small-heading': $vuetify.breakpoint.smAndDown}">{{this.langData.entry.subtitle}}</h1></div>
            </v-col>
            <v-col cols="1" class="rays-right"> 
                <!-- v-img
                    :src="lashesRight.src"
                    contain
                    :max-height="lashHeight"
                    max-width="22px"
                    class="float-left margin-sm-left"
                    v-show="$vuetify.breakpoint.mdAndUp"
                ></v-img>
                <v-img
                    :src="lashesRight.src"
                    contain
                    max-height="36"
                    max-width="22px"
                    class="float-left margin-sm-left"
                    v-show="$vuetify.breakpoint.smAndDown"
                ></v-img -->
            </v-col>
        </v-row>

      <v-row justify="center" alignment="center" v-if="uk">
        <v-col cols="10" md="4">
          <v-text-field
            v-model="form.accountNumber"
            :label="langData.entry.fieldLabels.accNo"
            required
            filled
            :rules="rules.accountNumberRules"
            :return-masked-value="maskInputs"
            v-mask="'########'"
            ></v-text-field>
        </v-col>
        <v-col cols="10" md="4">
            <v-text-field
            v-model="form.sortCode"
            :label="langData.entry.fieldLabels.sort"
            :return-masked-value="maskInputs"
            v-mask="'##-##-##'"
            filled
            :rules="rules.sortCodeNumberRules"
            ></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center" alignment="center" v-else>
        <v-col cols="10" md="4">
         <v-text-field
            v-model="form.iban"
            :label="langData.entry.fieldLabels.iban"
            required
            :rules="rules.ibanNumberRules"
            :return-masked-value="maskInputs"
            filled
            mask="AANNNNNNNNNNNNNNNNNNNN"
            @keyup="cleanIban()"
            ></v-text-field>	
        </v-col>
         <v-col cols="10" md="4" v-if="uk=='jam'">
            <v-text-field
            v-model="form.bic"
            :label="langData.entry.fieldLabels.bic"
            :return-masked-value="maskInputs"
            filled
            mask="AAAAAA#ANNN"
            ></v-text-field>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="10" md="8">
            <v-textarea
            v-model="form.statement"
            :rules="rules.statement"
            :label="langData.entry.fieldLabels.statement"
            filled
            ></v-textarea>
        </v-col>
      </v-row>

      <v-row justify="center" v-if="$vuetify.breakpoint.mdAndUp">
        <v-col cols="2" md="auto">
          <v-img
            :src="blankImg"
            contain
            min-width="78"
            max-width="78"
            @click="toggleTerms()"
            class="hover"
            right
          >
            <v-img
              :src="tickImg"
              contain
              v-show="form.terms"
            ></v-img>
          </v-img>
        </v-col>
        <v-col cols="auto" class="terms-label">
          <span :class="{'padding-left': $vuetify.breakpoint.mdAndDown}">{{this.langData.entry.tcLinkA}} <a @click="openModalPage('terms')">{{this.langData.entry.tcLinkB}}</a></span>
          <transition name="slide-y-transition" mode="in-out">
              <div class="v-text-field__details manual-error terms" v-if="errors.terms">
              <div class="v-messages theme--light error--text shift-right-small">
                  <div class="v-messages__wrapper">
                  <div class="v-messages__message" >{{errors.terms}}</div>
                  </div>
              </div>
              </div>
          </transition>
        </v-col>
      </v-row>

      <!-- v-row justify="center" alignment="center" no-gutters v-else>
        <v-col cols="auto">
          <v-img
            :src="blankImg"
            contain
            min-width="39"
            max-width="39"
            @click="toggleTerms()"
            class="hover margin-right-sm"
            right
          >
            <v-img
              :src="tickImg"
              contain
              v-show="form.terms"
            ></v-img>
          </v-img>
        </v-col>
        <v-col cols="8" md="auto">
          <span :class="{'padding-left-sm': $vuetify.breakpoint.mdAndDown}">{{this.langData.entry.tcLinkA}} <a @click="openModalPage('terms')">{{this.langData.entry.tcLinkB}}</a></span>
          <transition name="slide-y-transition" mode="in-out">
              <div class="v-text-field__details manual-error upload" v-if="errors.terms">
              <div class="v-messages theme--light error--text shift-right-small">
                  <div class="v-messages__wrapper">
                  <div class="v-messages__message" >{{errors.terms}}</div>
                  </div>
              </div>
              </div>
          </transition>
        </v-col>
      </!-->

      <v-row justify="center" alignment="center" no-gutters v-else>
        <v-col cols="auto">
          <v-img
            :src="blankImg"
            contain
            min-width="39"
            max-width="39"
            @click="toggleTerms()"
            class="hover margin-right-sm"
            right
          >
            <v-img
              :src="tickImg"
              contain
              v-show="form.terms"
            ></v-img>
          </v-img>
        </v-col>
        <v-col cols="8" md="auto">
          <div style="display: table; height:39px; overflow: hidden;">
            <div style="display: table-cell; vertical-align: middle;">
              <div class="tighten-leading">
                {{this.langData.entry.tcLinkA}} <a @click="openModalPage('terms')">{{this.langData.entry.tcLinkB}}</a>
              </div>
            </div>
          </div>
          <transition name="slide-y-transition" mode="in-out">
              <div class="v-text-field__details manual-error terms" v-if="errors.terms">
              <div class="v-messages theme--light error--text shift-right-small">
                  <div class="v-messages__wrapper">
                  <div class="v-messages__message" >{{errors.terms}}</div>
                  </div>
              </div>
              </div>
          </transition>
        </v-col>
      </v-row>

      <v-row justify="center">
          <v-col cols="auto">
              <span class="rays">
                <v-btn outlined uppercase color="#e93e8f" class="submit-button" @click="fullDone" :loading="loading" :disabled="loading">{{callToAction}}</v-btn>
              </span>
        </v-col>  
      </v-row>
      <v-row justify="center">
        <v-col cols="auto">
          <ul v-for="(data,i) in errorSummary" :key="i" class="v-messages__wrapper error--text">
            <li class="v-messages__message" >{{data}}</li>
          </ul>
          
        </v-col>
      </v-row>

      <v-row justify="center">
          <v-col cols="auto" class="lg-size">
              <p class="text-center">{{this.langData.entry.link3Text}} <a @click="openModalPage('faq')">{{this.langData.entry.link3Cta}}</a></p>
          </v-col>
      </v-row>

      <v-row justify="center" alignment="center">
          <v-col cols="10" md="7" class="text-green" ref="termsClick2">
              <p class="center-text mid-size"><b v-html="this.langData.shortTerms.body"></b></p>
          </v-col>
      </v-row>

     <v-dialog
      v-model="feedbackDialog"
      max-width="460"
      overlay-color="#eae6e7"
      overlay-opacity="0.36"
      >
      <v-card color="#f0eced" >
          <v-card-title class="headline text-white arla-strong center-text" :class="{'small-heading-modal': $vuetify.breakpoint.mdAndDown}" v-if="feedbackDialogTitle">
            <v-row justify="center">
                <v-col cols="auto" class="arla-strong" v-html="feedbackDialogTitle">
                </v-col>
            </v-row>
              
          </v-card-title>
          
          <v-card-text :class="feedbackDialogClass">
              
              <v-container v-if="feedbackDialogText">
                  <v-row>
                      <v-col cols='12' md='6'>
                          <v-img
                            :src="whereImg"
                            contain
                            v-show="$vuetify.breakpoint.mdAndDown"
                          ></v-img>
                      </v-col>
                      <v-col cols='12' md='6' class='text-green mid-size padded-left'>
                          <strong>{{this.langData.entry.modals.whereToFind.body}}</strong>
                     </v-col>
                  </v-row>
              </v-container>
              <v-container v-if="!feedbackDialogText&&!feedbackDialogClass">
                   <component v-bind:is="currentComponent" v-bind:lang-data="langData" v-bind:faq-data="faqData" v-bind:terms-data="termsData"></component>
              </v-container>
              <component v-bind:is="currentComponent" v-bind:lang-data="langData" v-bind:faq-data="faqData" v-bind:terms-data="termsData" v-if="feedbackDialogClass"></component>
          </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="errorDialog"
      max-width="460"
      overlay-color="#eae6e7"
      overlay-opacity="0.36"
      >
      <v-card color="#f0eced" >
          <v-card-title class="headline text-white arla-strong center-text" :class="{'small-heading-modal': $vuetify.breakpoint.mdAndDown}">
            <v-row justify="center">
                <v-col cols="auto" class="arla-strong" v-html="errorDialogTitle">
                </v-col>
            </v-row>
              
          </v-card-title>
          
          <v-card-text :class="errorDialogClass">
              <v-container>
                <p class="center-text"><strong v-html="errorDialogText"></strong></p>
              </v-container>
          </v-card-text>
      </v-card>
    </v-dialog>

    </v-container>
  </v-form>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import Faq from '../components/Faq'
import Terms from '../components/Terms'
import Receipt from '../components/Receipt'
import SiteData from '../data/content.json'
import Where from '../components/Where'

export default {
  props:['siteData', 'langData', 'country'],
  name: 'FullForm',
  components : {
      Faq,
      Terms,
      Receipt,
      Where
  },
  mounted() {
    if(this.$refs['termsClick'].firstChild.firstChild.childNodes[1]) {
      this.$refs['termsClick'].firstChild.firstChild.childNodes[1].addEventListener('click', (event) => {
        this.openModalPage('terms');
      })
    }
    if(this.$refs['termsClick2'].firstChild.firstChild.childNodes[1]) {
      this.$refs['termsClick2'].firstChild.firstChild.childNodes[1].addEventListener('click', (event) => {
        this.openModalPage('terms');
      })
    }
    if(navigator.language == 'en-GB') {
      this.uk = true
      this.faqData = require('../data/faq.new.json')
      this.termsData = require('../data/terms.json')
    }else{
      this.uk = false
      this.faqData = require('../data/faq.new.nl.json')
      this.termsData = require('../data/terms.nl.json')
    }
    if(window.location.origin == 'https://arlanl.promonow.io' || window.location.origin == 'https://staging.arlanl.promonow.io') {
      this.uk = false
      this.faqData = require('../data/faq.new.nl.json')
      this.termsData = require('../data/terms.nl.json')
    }else{
      this.uk = true
      this.faqData = require('../data/faq.new.json')
      this.termsData = require('../data/terms.json')
    }
    console.log(this.termsData)
  },
  data: (el=this) => ({
    valid: false,
    pageData: SiteData,
    faqData: {},
    termsData: {},
    currentComponent: Where,
    feedbackDialog: false,
    feedbackDialogTitle: el.langData.entry.modals.whereToFind.title,
    feedbackDialogText: false,
    feedbackDialogClass: el.langData.entry.modals.whereToFind.class,
    errorDialog: false,
    errorDialogTitle: el.langData.entry.modals.entryLimit.title,
    errorDialogText: false,
    errorDialogClass: 'error',
    code: '',
    callToAction: el.langData.entry.submitButton,
    lashesRight : {src:require('../assets/lashesRight.png')},
    lashesLeft : {src:require('../assets/lashesLeft.png')},
    lashHeight: '54px',
    whereImg: {src:require('../assets/whereToFind.png')},
    blankImg: {src:require('../assets/blankBox.png')},
    tickImg: {src:require('../assets/TickIcon.svg')},
    urnError: false,
    urnErrorMessages: [],
    imageMaxHeight: '300',
    codeFormLoading: false,
    errors: {
      captcha: false,
      code: false,
      terms: false,
      file: {
          front: false,
          back:false
      }
    },
    codeError:false,
    errorMessage: el.langData.entry.validation.code.required,
    folder:false,
    form: {
      firstname:'',
      lastname: '',
      email: '',
      emailConfirm: '',
      address1: '',
      address2: '',
      address3: '',
      postcode: '',
      product: '',
      terms: 0,
      statement: '',
      accountNumber: '',
      sortCode: '',
      iban: '',
      bic: '',
      code: '',
      captcha: false,
      captchaToken: ''
    },
    files: [],
    filesBack: [],
    errorSummary: [],
    uploadImage: false,
    uploadImageBack: false,
    email: '',
    emailConfirm: '',
    emailConfirmError: false,
    emailConfirmErrorMessage: [],
    doneLoading: false,
    submitted: false,
    seasonedId: 0,
    uk: false,
    maskInputs: true,
    loading: false,
    rules: {
      emailInput: [
          v => !!v || el.langData.entry.validation.email.required,
          v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || el.langData.entry.validation.email.pattern
      ],
      terms:[
          v => !!v || el.langData.entry.validation.terms.required
      ],
      firstName: [
          v => !!v || el.langData.entry.validation.firstName.required,
          v => v.length > 1 || el.langData.entry.validation.firstName.length
      ],
      lastName: [
          v => !!v || el.langData.entry.validation.lastName.required,
          v => v.length > 1 || el.langData.entry.validation.lastName.length
      ],
      county: [
          v => !!v || el.langData.entry.validation.county.required
      ],
      address1: [
        v => !!v || el.langData.entry.validation.address1.required
      ],
      address2: [
        v => !!v || el.langData.entry.validation.address2.required
      ],
      address3: [
        v => !!v || el.langData.entry.validation.address3.required
      ],
      postcode: [
        v => !!v || el.langData.entry.validation.postcode.required,
        v => /\b(GIR ?0AA|SAN ?TA1|(?:[A-PR-UWYZa-pr-uwyz](?:\d{0,2}|[A-HK-Ya-hk-y]\d|[A-HK-Ya-hk-y]\d\d|\d[A-HJKSTUWa-hjkstuw]|[A-HK-Ya-hk-y]\d[ABEHMNPRV-Ybaehmnprv-y])) ?\d[ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})\b/.test(v) || el.langData.entry.validation.postcode.pattern
      ],
      postcodeNL: [
        v => !!v || el.langData.entry.validation.postcode.required,
        v => /^(?:NL-)?(\d{4})\s*([A-Z]{2})|([1-9]{1}[0-9]{3})$/i.test(v) || el.langData.entry.validation.postcode.pattern
      ],
      statement: [
          v => !!v || el.langData.entry.validation.statement.required,
          //v => /(?:[\w\']+(\b|\s+)){15,}/.test(v) || el.langData.entry.validation.statement.pattern
          v => /([éëïóöü€’”„“”–—ÉËÏÖÓÜ\u0000-\uFFFF\w]+[\b\s\.]){15,}/.test(v) || el.langData.entry.validation.statement.pattern
      ],
      code: [
          v => !!v || el.langData.entry.validation.code.required,
          v => /([A-Za-z]{1}[0-9]{6})|([0-9]{4}[a-zA-Z]{1}[0-9]{4})/.test(v) || el.langData.entry.validation.code.pattern
      ],
      codeNL: [
          v => !!v || el.langData.entry.validation.code.required,
          v => /([A-Z]{1})([0-9]{5})|([0-9]{8})/i.test(v) || el.langData.entry.validation.code.pattern
      ],
      accountNumberRules: [
        v => !!v || el.langData.entry.validation.accountNumber.required,
        v => v != '00000000' || el.langData.entry.validation.accountNumber.invalid,
        v => /^\d{8}$/.test(v) || el.langData.entry.validation.accountNumber.pattern
      ],
      sortCodeNumberRules: [
        v => !!v || el.langData.entry.validation.sortCode.required,
        v => v != '00-00-00' || el.langData.entry.validation.sortCode.invalid,
        v => /(\d{6})|(\d{2}-\d{2}-\d{2})/.test(v) || el.langData.entry.validation.sortCode.pattern
      ],
      ibanNumberRules: [
        v => !!v || el.langData.entry.validation.iban.required,
        v => /([a-zA-Z]{2}[0-9]{2})([a-zA-Z]{4})([0-9]{4}){2}([0-9]{2})|([a-zA-Z]{2}[0-9]{14})/.test(v) || el.langData.entry.validation.iban.pattern
      ],
      bicSwiftNumberRules: [
        v => /^[a-z]{4}[a-z]{2}[0-2][a-z]([0-9a-z]{3}|)/i.test(v) || el.langData.entry.validation.bic.pattern
      ]
    },
  }),
  components: {
    'v-captcha' : VueRecaptcha
  },
  created() {
    this.content = this.langData.code
  },
  methods: {
    toggleTerms: function() {
      if(this.form.terms) {
        this.form.terms = false
      }else{
        this.form.terms = true
        this.errors.terms = false
      }
    },
    cleanIban: function() {
      this.form.iban = this.form.iban.replace(/[^0-9a-z]/gi, '')
    },
    cleanCode: function() {
      this.form.code = this.form.code.replace(/[^0-9a-z]/gi, '')
      console.log(this.form.code)
      this.validateCode()
    },
    validateCode: function() {
      // regex
      if(this.uk) {
        var tmp = this.form.code.match(/([A-Za-z]{1}[0-9]{5,6})|([0-9]{4}[a-zA-Z]{1}[0-9]{4})/), match = false
      }else{
        var tmp = this.form.code.match(/([A-Z]{1})([0-9]{5})|([0-9]{8})/i), match = false
      }
      
      if(tmp) {
        // match found
        match = tmp.includes(this.form.code)
      }
      if(this.form.code=='' || !match) {
        this.codeError = true
        if(this.form.code=='') {
          this.errorMessage = this.langData.entry.validation.code.required
        }else if(!match) {
          this.errorMessage = this.langData.entry.validation.code.pattern
        }
      }else{
        this.codeError = false
      }
    },
      chooseFiles:function(target) {
        document.getElementById(target).value = ''
        document.getElementById(target).click()
      },
      fullDone:function() {
        this.validateEmail()
        this.validateCode()
        console.log(this.$refs.fullForm.validate())
        if(!this.form.captcha) {
          this.errors.captcha = this.langData.entry.validation.captcha.required
          this.loading = false
        }
        if(!this.files.name) {
          this.errors.file.front = this.langData.entry.validation.imageFront.required
          this.loading = false
        }
        if(!this.form.terms) {
          this.errors.terms = this.langData.entry.validation.terms.required
          this.loading = false
        }
        if(this.$refs.fullForm.validate() && this.form.captcha && this.files.name && this.form.terms && !this.codeError){
          this.loading = true
          this.errorSummary = []
          // build postdata
          var formData1 = new FormData(),
          formData = new FormData(),
          api = '/api/processFullNew',
          api1 = '/api/testCall', 
          api2 = '/api/processAsync',
          api3 = '/api/storeBankDetails'
          formData.append('code', this.form.code)
          formData1.append('urn', this.form.code)
          formData.append('receipt', this.files)
          formData.append('receiptBack', this.filesBack)
          formData.append('firstName', this.form.firstname)
          formData.append('lastName', this.form.lastname)
          formData.append('email', this.form.email)
          formData.append('address1', this.form.address1)
          formData.append('address2', this.form.address2)
          formData.append('address3', this.form.address3)
          formData.append('postcode', this.form.postcode)
          formData.append('terms', this.form.terms)
          formData.append('statement', this.form.statement)
          if(this.form.accountNumber!='' || this.country == 'en') {
            formData.append('accNum', this.form.accountNumber)
            formData.append('sortCode', this.form.sortCode)

          }else{
            formData.append('bic', this.form.bic)
            formData.append('iban', this.form.iban)
          }
          formData.append('captchaToken', this.form.captchaToken)
          formData.append('token', this.form.captchaToken)
          formData1.append('token', this.form.captchaToken)
          formData.append('country', this.country)
          // need to be reworked API side
          formData.append('product', 'lactoFREE')
          formData.append('purchaseDate', new Date)
          formData.append('retailer', 'Arla')
          this.formSubmitted = true
          /*if(window.location.origin == 'https://staging.arlanl.promonow.io') {*/
            this.axios.post(api, formData).then((response)=>{
              
              if(response.data.success) {
                this.loading = false
                this.$router.push('/thanks');
                this.$emit('full-form-done', 2);
              }else{
                this.loading = false
                // handle rerrors
                this.handleError(response.data.errors[0])
              }
            });
          /*}else{
            this.axios.post(api1, formData1).then((response)=>{
              if(response.data.success) {
                this.loading = false
                // success - seaseonedId -> processAsync
                formData.append('seasonedId', response.data.payload.seasonedId)
                this.axios.post(api2, formData).then((response)=>{

                });
                this.axios.post(api3, formData).then((response)=>{
                  
                });
                this.$router.push('/thanks');
                this.$emit('full-form-done', 2);
              }else{
                this.loading = false
                // handle rerrors
                //this.handleError(processResponse.data.errors)
              }
            });
          }*/
        }else{
          setTimeout(() => {
            this.scrollToError()
            this.$el.querySelectorAll('.error--text .v-messages__message').forEach((e) => {
              this.errorSummary.push(e.innerText)
            })
          }, 200);
        }
      },
      scrollToError: function () {
        var el = null;
        if(document.querySelector(".error--text:first-of-type")) {
          el = document.querySelector(".error--text:first-of-type");
        }else if(document.querySelector(".v-btn.error:first-of-type")) {
          el = document.querySelector(".v-btn.error:first-of-type");
        }else if(document.querySelector(".captcha-error:first-of-type")) {
          el = document.querySelector(".captcha-error:first-of-type");
        }
        console.log(el);
        if(el) {
          el.scrollIntoView({behavior:'smooth', alignToTop: true});
          return;
        }
      },
      captchaClick : function (recaptchaToken) {
        this.form.captcha = true
        this.errors.captcha = false
        this.form.captchaToken = recaptchaToken
      },
      validateEmail: function() {
      if(!this.form.emailConfirm) {
        this.emailConfirmError = true
        this.emailConfirmErrorMessage = [this.langData.entry.validation.emailConfirm.required]
        return false
      }else if(this.form.emailConfirm == this.form.email) {
        this.emailConfirmError = false
        this.emailConfirmErrorMessage = []
        return true
      }else{
        this.emailConfirmError = true
        this.emailConfirmErrorMessage = [this.langData.entry.validation.emailConfirm.match]
        return false
      }
    },
    fileFrontChanged : function (event) {
      //this.$refs.uploadForm.validate();
      console.log('front change')
      this.imageError = false;
      this.errors.file.front = false
      console.log(event)
      // Handle file as object
      // If multiple {file} is object array
      // Chain api calls and feedback to user
      if(event.name) {
        this.errors.file.front = false
        this.file = event
        this.receipt = event;
        //var image = new Image();
        var reader = new FileReader();
        var vm = this;
        var extension = this.file.name.substring(this.file.name.lastIndexOf('.')).toLowerCase()
        reader.onload = (e) => {
          if(this.file.type != 'application/pdf' && extension != '.heic' && this.file.type.substring(0, this.file.type.lastIndexOf('/'))=='image') {
            vm.uploadImage = e.target.result;
            this.imageMaxHeight = '300'
          }else if (extension == '.heic') {
            vm.uploadImage = {src:require('../assets/heic-icon-256x256@2x.webp')}
            this.imageMaxHeight = '150'
          }else if(this.file.type.substring(0, this.file.type.lastIndexOf('/'))=='image') {
            vm.uploadImage = {src:require('../assets/pdf-icon.png')}
            this.imageMaxHeight = '150'
          }else{
            this.errorDialogText = this.langData.entry.validation.imageFront.unsupported    
            this.errorDialogTitle = this.langData.entry.validation.imageFront.title            
            this.errorDialog = true
          }
        };
        reader.readAsDataURL(event);
      }
    },
    removeImage: function(tgt) {
      if(tgt == 'back') {
        this.uploadImageBack=false
        this.filesBack = []
        this.errors.file.back = false
      }else{
        this.uploadImage=false
        this.files = []
        this.errors.file.front = false
      }
    },
    fileBackChanged : function (event) {
      //this.$refs.uploadForm.validate();
      this.imageError = false;
      this.errors.file.back = false
      // Handle file as object
      // If multiple {file} is object array
      // Chain api calls and feedback to user
      if(event.name) {
        this.errors.file.back = false
        this.fileBack = event
        this.receiptBack = event;
        //var image = new Image();
        var reader = new FileReader();
        var vm = this;
        var extension = this.fileBack.name.substring(this.fileBack.name.lastIndexOf('.')).toLowerCase()
        reader.onload = (e) => {
          if(this.fileBack.type != 'application/pdf' && extension != '.heic' && this.fileBack.type.substring(0, this.fileBack.type.lastIndexOf('/'))=='image') {
            vm.uploadImageBack = e.target.result;
          }else if (extension == '.heic') {
            vm.uploadImageBack = {src:require('../assets/heic-icon-256x256@2x.webp')}
          }else if(this.fileBack.type.substring(0, this.fileBack.type.lastIndexOf('/'))=='image') {
            vm.uploadImageBack = {src:require('../assets/pdf-icon.png')}
          }else{
            this.errorDialogText = this.langData.entry.validation.imageFront.unsupported    
            this.errorDialogTitle = this.langData.entry.validation.imageFront.title            
            this.errorDialog = true
          }
        };
        reader.readAsDataURL(event);
      }
    },
    handleError: function (error) {
      this.errorDialog = true
      this.errorDialogTitle = this.langData.entry.modals.entryLimit.title
      this.errorDialogText = error 
      this.errorDialogClass = false
    },
    openModalPage: function(target) {
        this.feedbackDialog = true
        this.feedbackDialogTitle = false
        this.feedbackDialogText = false 
        this.feedbackDialogClass = false
        if(target=="faq") {
            this.currentComponent = Faq
        }else if(target == 'terms'){
            this.currentComponent = Terms
        }else if(target == 'receipt') {
            this.feedbackDialogTitle = this.langData.entry.modals.howTo.title
            this.currentComponent = Receipt
        }else{
            /*this.feedbackDialogText = true*/
            this.feedbackDialogTitle = this.langData.entry.modals.whereToFind.title
            /*this.feedbackDialogText = this.langData.entry.modals.whereToFind.body*/
            this.feedbackDialogClass = this.langData.entry.modals.whereToFind.class
            this.currentComponent = Where
        }
    }
  },
  watch : {
    email: function(val) {
      console.log(val)
      if(val!=''&&this.emailConfirm!='') {
        this.validateEmail()
      }
    },
    code: function(val) {
      console.log(val)
    }
  }
};
</script>
